module.exports = __webpack_public_path__ + "img/ring_y_skip_null_0.8fec8c7e.png";